"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useServerHelpUrlByToken = void 0;
// Borrows from VPC's HelpService.ts: src/commonInfra/services/HelpService.ts
const catalog_core_1 = require("@tableau/catalog-core");
const help_link_library_1 = require("@tableau/help-link-library");
const ONLINE_TOKEN_OFFLINE_PAGE_DICT = {
    'adminusers2': 'csvguidelines.htm',
    'status1': 'service_viewstatus.htm',
    'settings-adsync1': 'groups_globalsync.htm',
};
function useServerHelpUrlByToken(helpToken) {
    const { helpUrlParams } = (0, catalog_core_1.useUserSiteSettings)();
    const edition = (helpUrlParams === null || helpUrlParams === void 0 ? void 0 : helpUrlParams.serverHelpEdition) || 'server';
    const language = (helpUrlParams === null || helpUrlParams === void 0 ? void 0 : helpUrlParams.sessionLanguage) || 'en-us';
    const platform = getServerPlatform(helpUrlParams === null || helpUrlParams === void 0 ? void 0 : helpUrlParams.serverPlatform);
    const version = getExternalVersion(helpUrlParams === null || helpUrlParams === void 0 ? void 0 : helpUrlParams.serverVersion);
    const offlineHelpEnabled = helpUrlParams === null || helpUrlParams === void 0 ? void 0 : helpUrlParams.offlineHelpEnabled;
    if (offlineHelpEnabled) {
        return offlineHelpRoute(language, ONLINE_TOKEN_OFFLINE_PAGE_DICT[helpToken !== null && helpToken !== void 0 ? helpToken : '']);
    }
    else {
        if (helpToken === undefined || helpToken === 'undefined' || !helpToken) {
            return buildUrl({ edition, helpToken: 'server-help1', language, platform, version });
        }
        const fullHelpToken = 'server-'.concat(helpToken);
        return buildUrl({ edition, helpToken: fullHelpToken, language, platform, version });
    }
}
exports.useServerHelpUrlByToken = useServerHelpUrlByToken;
function buildUrl(args) {
    const { edition, helpToken, language, platform, version } = args;
    const helpLinkObj = new help_link_library_1.HelpLinkLibrary();
    helpLinkObj.setLanguage(language);
    const helpLanguage = helpLinkObj.getLanguage();
    helpLinkObj.setHelpUrl(helpLanguage, edition, version, helpToken, platform);
    const retval = helpLinkObj.getHelpUrl();
    return retval;
}
function getExternalVersion(serverVersion) {
    if (!serverVersion) {
        return '0.0';
    }
    const intRegExp = /^\d+$/;
    if (intRegExp.test(serverVersion.major) && intRegExp.test(serverVersion.minor)) {
        return serverVersion.major + '.' + serverVersion.minor;
    }
    else {
        return '0.0';
    }
}
function getServerPlatform(platform) {
    return platform ? platform.toLowerCase() : 'windows'; // Default to Windows
}
function offlineHelpRoute(language, page) {
    const lang = helpUrlLanguage(language).replace('-', '_');
    return 'offline_help/' + lang + '/help.htm' + (page ? '#' + page : '');
}
function helpUrlLanguage(language) {
    const helpLinkObj = new help_link_library_1.HelpLinkLibrary();
    helpLinkObj.setLanguage(language);
    return helpLinkObj.getLanguage();
}
//# sourceMappingURL=HelpLinkService.js.map